export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Codigo',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.code;
                    }
                },
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.accreditation.organization.name;
                    }
                },
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        if(item.type == 'E'){
                            return 'Evaluación';
                        }else{
                            return 'Testificación';
                        }
                        
                    }
                },
                {
                    title: 'Planificado desde',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return `${item.date_start} ${item.time_start}`;
                    }
                },
                {
                    title: 'Planificado hasta',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return `${item.date_end} ${item.time_end}`;
                    }
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}